import React from 'react'
import { Pane, Text } from 'evergreen-ui'
import {
  isMajorInInterviewList,
  isMixedInterviewRound,
  resolveRoundFlag,
  useStatusContent,
} from '../../../config/roundContent'

const DetailComment = ({ DataRegister }) => {
    const row = DataRegister?.[0] || {}
    const { content, statusContent } = useStatusContent(row.ROB_ID, row.REGISTER_STATUS)
    const typeId = row.REGISTER_TYPE_ID
    const majorId = DataRegister[0]?.Major_MAJOR_ID || DataRegister[0]?.Major1_MAJOR_ID

    // กรองแบบเดิมสำหรับบางประเภท — แต่ข้อความมาจาก byStatus
    const showByType = (() => {
        if (typeId === "1" || typeId === "5") {
            // หมายเหตุเฉพาะสาขาที่ต้องสัมภาษณ์
            if (resolveRoundFlag(content, "commentInterviewNote", row.ROB_ID)) {
                if (isMixedInterviewRound(content, row.ROB_ID)) {
                    return isMajorInInterviewList(content, majorId)
                }
                return isMajorInInterviewList(content, majorId)
            }
            return true
        }
        if (typeId === "4" || typeId === "7" || typeId === "2" || typeId === "3") {
            return true
        }
        return Boolean(statusContent.noteVisible)
    })()

    if (!showByType || !statusContent.noteVisible || !statusContent.noteText) {
        return null
    }

    return (
        <Pane
            color="#fff"
            backgroundColor="#ff0000ff"
            height="100%"
            paddingY={4}
            paddingX={5}
            fontSize={14}
            margin={0}
            fontWeight={700}
            display="flex"
            flexDirection="column"
            marginTop={5}
        >
            <Text fontWeight={600} fontSize={14} color="#ffffff">
                {statusContent.noteText}
            </Text>
        </Pane>
    )
}

export default DetailComment
